<template>
  <div id="donor_login_app" ref="main" class="mb-5">
    <div class="text-center p-5" v-if="!ready">
      <b-spinner style="width: 3rem; height: 3rem;" />
    </div>
    <template v-else>
      <div v-if="error" class="text-center p-5"> 
        Your session has timed out. <a href="#" @click.prevent="reload">Click here</a> to refresh the page.
      </div>
      <template v-else>
        <div v-if="!login">
          <h1 class="text-center account_heading py-3">Login first:</h1>
          <hr/>
          <login :fb_link="fb_link" :google_link="google_link" :otp="otp" :axios="axios"/>
        </div>
        <div v-else>
          <h1>
            The page can’t be found.
          </h1>
          <p>
            It looks like nothing was found at this location.
          </p>


        </div>
      </template>
      
    </template>
  </div>
</template>

<script>
import axios from 'axios';
//import VueScrollTo from 'vue-scrollto';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import login from './components/login.vue';




if(window.Vue){
  window.Vue.use(BootstrapVue)
  window.Vue.use(IconsPlugin)
}
export default {
  name: 'App',
  components: {
    login
  },
  props:{
    nonce:String
  },
  data(){
    let nounce_token = this.nonce;
    return{
      nounce_token,
      error:false,
      ready: false,
      user: null,
      fb_link: null,
      google_link: null,
      login: null,
      stripe_key: null,
      otp:{
        sent: false,
        invalid: true,
        verifying: false
      },
      stripe: null,
    }
  },
  mounted(){
    this.init();
    window.addEventListener("message", e=>{
      if(e.origin =="https://give.healthserve.org.sg"){
        if(e?.data?.nonce){
          console.log('login again');
          this.reload();
        }
      }

    });
  },
  methods:{
    init(){
      this.error = this.ready = false;
      this.refresh_login();
    },
    async refresh_login(){
      await this.axios.get('init').then(rsp=>{
        let {data} = rsp;
        this.ready = true;
        Object.assign(this, data);
      }).catch(()=>{
        this.ready = true;
        this.error = true;
      });


    },
    reload(){
      window.location.reload();
    },
    logout(){
      this.axios.get('logout').then(()=>{
        window.location.reload();
      }).catch(()=>{
        window.location.reload();
      });
    },
    async rerun_login(nonce){
      this.nounce_token = nonce;
      await this.refresh_login();

    }
  },
  computed:{
    axios(){
      return axios.create({  
        headers: {'X-WP-Nonce': this.nounce_token},
        baseURL: '/wp-json/tq_donate/v1/'
      })
    },
  }
}
</script>

<style lang="scss">

  #donor_login_app{
    font-family: Lato, sans-serif;    
  
  $primary: #9C1D20;
  $hsCrimson: #9C1D20;
  $hsBlue:#3F3E84;
  $hsDarkGray:#828282;
  $lineGray: #BDBDBD;
  
  $theme-colors: (
    "hs-crimson-6": #F8EBE4,
    "hs-crimson": $hsCrimson,
    "hs-pastel-crimson":  #F4E3DC,
    "hs-green":  #408D94,
    "hs-light-turquoise": #81CACF,
    "hs-black": #333333,
    "hs-dark-gray":$hsDarkGray,
    "hs-gray":#BDBDBD,
    "hs-light-green":#A2D7DC,
    "hs-dark-turquoise": #3491A8,
    "hs-blue": $hsBlue

  );

  @import '~bootstrap';
  @import '~bootstrap-vue';
  @import "vue-select/src/scss/vue-select.scss";
  
  .account_heading{
    font-size: 24px;

  }
 
  .vs__selected-options{
    padding: 0.125rem 0.325rem;
    input::placeholder{
      color: #828282;
    }
  }
  input::placeholder{
      color: #828282;
  }
  @include media-breakpoint-up(md) {    
    .split-radio-btns.btn-group > .btn:not(:first-child), 
    .split-radio-btns.btn-group > .btn-group:not(:first-child){
        margin-left:1rem;
    }
  }
    @include media-breakpoint-down(md) {    
          .split-radio-btns.btn-group > .btn, 
          .split-radio-btns.btn-group > .btn-group,
          .responsive-radios-btns .btn-group-toggle{
            width:100%;
            margin-bottom: .5rem;
          }
          
          .responsive-radios-btns .btn-group-toggle .btn
          {
              width:100%;

          }

    }
  .cc-table-data tr{ 
      >td:first-child,
      >th:first-child{
        width: 50px;
        vertical-align: middle;
      }
  }
  .split-radio-btns.btn-group > .btn{
      border-radius:.3rem !important;
      padding:.5rem 3rem;
  }
  .split-radio-btns.btn-group.narrow > .btn{
      padding:.5rem 2rem;
  }
  .split-radio-btns.btn-group > .btn:not(:hover):not(:active):not(.active){
    background-color: #fff;
  }
  .currency.small{
    font-size: .6em;
  }
  .info-bubble{
    background: #FFFFFF;
    border: 1px solid $primary;
    box-sizing: border-box;
    border-radius: 6px;
    text-align:center;
    padding: .5rem .7rem;
  }
  .info-caption{
    padding: .5rem .7rem;
    box-sizing: border-box;

  }
    .split-radio-btns.btn-group {
      flex-wrap: wrap;
    }

  .part-2-fields .form-text{
    margin-left: .250rem 
  }
  .pseudo-input{
    position: absolute;
    width: calc(100% - 1px); height: calc(100% - 1px);
    border: none;
    border-radius: 5px;
    background: none;
    left: 0%; bottom: 0;
    z-index: -1;
    opacity: 0;
  }
        .StripeElement{
          border:1px solid #ced4da !important;

        }

        .StripeElement--focus {
            border-color:$primary !important;
            outline:0;
            box-shadow: 0 0 0 .2rem fade-out($primary, .75) !important;
            transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        }

.vs__search, .vs__search:focus {
        width:0 !important;
        border: 1px solid transparent !important;
        border-left: none !important;
    }

  #dashboard-tabs{
    .nav-pills{
      .nav-link{
        border-radius: 0;
        color: $hsDarkGray;
        margin: 0 10px;
      }
      .nav-link:hover{
        color: $hsBlue;
      }
      .nav-link.active,.show > .nav-link{
        background-color: transparent;
        color: $hsBlue;
        border-bottom: solid 6px;
      } 

    } 
  }
    .info-list{
      display: grid;
      grid-template-columns: 250px auto;
      color: $hsDarkGray;
    }
    .info-list > div{
      border-bottom: solid 1px $lineGray;
      padding: 25px 20px 10px;
      display: flex;
      align-items: center;
    }
  }
</style>
